import { Stack, Typography } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import { Trans } from "react-i18next";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";
import {
  Resources,
  useResource,
  getResourcePath,
} from "Translations/Resources";

const RESOURCES = Resources.Components.Affiliate.Earnings;

type Props = {
  value: string;
  isLoading: boolean;
  tier1Count: number;
  tier2Count: number;
  tier3Count: number;
};

export const RegisteredUsersTile = ({
  value,
  isLoading,
  tier1Count,
  tier2Count,
  tier3Count,
}: Props) => {
  const { t } = useResource();

  return (
    <ValueTile
      isLoading={isLoading}
      icon={<PeopleIcon />}
      title={t(RESOURCES.TotalRegisteredUsers)}
      value={value}
      explanationHint={
        <Stack gap={4}>
          <Typography
            fontSize="1rem"
            color="text.secondary"
            fontWeight={400}
            sx={{ strong: { color: "text.primary", fontWeight: 400 } }}
          >
            <Trans
              i18nKey={getResourcePath(RESOURCES.RegisteredUsersHint)}
              values={{
                t1: tier1Count,
                t2: tier2Count,
                t3: tier3Count,
              }}
              components={{
                newline: <br />,
                bold: <strong />,
              }}
            />
          </Typography>
        </Stack>
      }
    />
  );
};
